import React, { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import axios from "axios";
import { customBaseUrl } from "./store/http";
import ForgotPassword from "./views/Auth/ForgotPassword";
import ResetPassword from "./views/Auth/ResetPassword";
import ManageUser from "./views/ManageUser";
import Login from "./views/Auth/Login";

import Kyc from "./views/Kyc";
import BusinessType from "./views/Kyc/BusinessType";
import WayaOfficial from "./views/WayaOfficial";
import { ProfileContextProvider } from "./store/context/ProfileContext";
import AdminVendors from "./views/Tech/adminVendors";
import Dashboard from "./views/dashboard/screen";
import Admin from "./views/admin";
import ManageAdminRoles from "./views/admin/manageRoles";
import Profile from "./views/ManageUser/profile";
import KycMainPage from "./views/Kyc/kycUserTier/kycMain";
import KycSettings from "./views/Kyc/kycSettings";
import UserLoginTracker from "./views/ManageUser/user-activity/user-login-tracker";
import slugs from "./resources/slugs";
import Otp from "./views/Otp";
import AdminAccountVerification from "./views/account-verification";
import AllTransaction from "./views/Transaction/AllTransaction";
import ManualReport from "./views/Transaction/ManualReports";
import AggreegatorBill from "./views/Tech/AggregatorBill";
import ComingSoon from "./views/coming-soon";
import ChangeTransactionCharges from "./views/Transaction/TransactionCharges/ChangeTransactionFees";
import UserActivityLog from "./views/ManageUser/user-activity/activity-log";
import QR from "./views/QR/QrCode";
import Dispute from "./views/dispute";
import NonWayaTransfer from "./views/Transaction/NonWayaTransfer/index";
import FeedBack from "./views/Feedback";
import Accounts from "./views/accounts";
import PaymentRequest from "./views/Transaction/PaymentRequest";

import BillsPayment from "./views/BillsPayment";
import TechOverview from "./views/Tech/TechOverview";
import SimulatedUsersFund from "./views/Tech/TechOverview/Funds";
import ManageRefferrals from "./views/users/ManageRefferal";
import TransactionsDone from "./views/users/ManageRefferal/transactionsDone";
import UsersOverview from "./views/Tech/SimulatedUsers";
import SimulatedUsers from "./views/Tech/SimulatedUsers/simulatedUsers";
import Commission from "./views/Commission";
import BonusEarned from "./views/users/ManageRefferal/bonusEarned";
import TermsCondition from "./views/contents/termsancCondition";
import Privacy from "./views/contents/privacy";
import Disputes from "./views/Transaction/Disputes";
import EditSuperProfile from "./views/ManageUser/profile/editProfile";
import ManageTeam from "./views/ManageUser/teamMembers";
import RequestLogs from "./views/Logs/request-log";
import AdminAuditLogs from "./views/Logs/admin-log";
import FraudManagement from "./views/Logs/fraudManagement";
import MainPricing from "./views/Tech/pricing/main";
import CardsMainPage from "./views/cards";
import SMUTransactions from "./views/Transaction/AllTransaction/smTransactions";
import DashboardAnalysis from "./views/dashboard/dasboardAnalysis";
import Referrals from "./views/users/ManageRefferal/referal";
import LoanOverview from "./views/Loan/overview";
import ApproverLogin from "./views/Auth/ApproverLogin";
import BulkCardMain from "./views/bulkCard/BulkCardsMain";
import ProfilePage from "./views/ManageUser/profile/profilePage";
import PosDashboard from "./pos/pages/Dashboard/Dashboard";
import PosDeviceDetails from "./pos/components/PosComponents/PosDeviceDetails";
// import Terminals from "./pos/pages/Terminals/Terminals";
// import Settlement from "./pos/pages/Transactions/Settlement";
import Transaction from "./pos/pages/Transactions/Transaction";
// import POSTransactions from "./pos/pages/Transactions/Transactions";
import ProductsTransactions from "./components/ManageWallet/Transaction History/productTransactions";
import ProductPricing from "./views/Tech/AggregatorBill/productPricing";
import AllUsers from "./views/all-users/screen";
import CustomerDetailsScreen from "./views/all-users-details/screen";
import MerchantDetails from "./pos/components/UsersComponents/MerchantDetails";
import ManageKyc from "./views/ManageKyc";
import TransactionList from "./views/transactions";
import LoanAdminLogin from "./views/Auth/LoanAdminLogin";
import LoanAdminDashboard from "./views/Loan/LoanAdminDashboard";
import LoanDetailsPage from "./views/Loan/LoanDetailsPage";
import LoanOfficerDetailsPage from "./views/Loan/LoanOfficerDetailsPage";
import FinanceOfficerDetailsPage from "./views/Loan/FinanceOfficerDetailsPage";
import LoanAdmins from "./views/Loan/LoanAdmins";
import Disbursement from "./views/Disbursement";
import FinanceApproverDisbursement from "./views/Loan/FinanceApproverDisbursement";
import AdminSummaryPage from "./views/AdminSummaryPage"; // Import the new component
import LoanPendingLoans from "./views/Loan/LoanPendingLoans"; // Import new component
import ApplyForLoan from "./views/Loan/ApplyForLoan";
import AllLoansPage from "./views/Loan/AllLoansPage";
import LoanAuditLogsPage from "./views/Loan/LoanAuditLogsPage";
import LoansByStatusPage from "./views/Loan/LoansByStatusPage";
import LoanSettings from "./views/Loan/LoanSettings";
import LoanViewPage from "./views/Loan/LoanViewPage";
import B2BProducts from "./views/B2BProducts";
import ProductPricingPage from "./views/B2BProducts/Pricing";
import B2BReports from "./views/B2BProducts/Reports";
import ProductTransactionsPage from "./views/B2BProducts/ProductTransactions/ProductTransactionsPage";
import MerchantTransactionsPage from "./views/B2BProducts/ProductTransactions/MerchantTransactionsPage";
import Settings from "./views/Settings";
import AppSettings from "./views/Settings/AppSettings";
import Vendors from "./views/Settings/Vendors";
import NipInwardReconciliation from "./views/Transaction/NipInwardReconciliation";
import CommissionTypeList from "./views/CommissionConfig/CommissionTypeList";
import CommissionConfigList from "./views/CommissionConfig/CommissionConfigList";
import Routing from "./pos/pages/Tech/Routing";
import CustomerManagementReports from "./views/CustomerManagementReports";
import CorporateCustomerReports from "./views/CorporateCustomerManagement";
import OtpManagement from "./views/Settings/OtpManagement";
import { AdminDetailsScreen } from "./views/admin-details/screen";
import CorporateManagementScreen from "./views/corporate-management/screen";
import CorporateCustomerManagement from "./views/CorporateCustomerManagement/index";
import CustomerManagement from "./views/CustomerManagementReports/index";
import CustomerProfile from "./views/CustomerManagementReports/CustomerProfile";
import ActivityLogs from "./views/ActivityLogs";
import AuditTrail from "./views/AuditTrail";
import RegulatoryReporting from "./views/RegulatoryReporting";
import InternalReporting from "./views/InternalReporting";
import CampaignList from "./views/Campaign/CampaignList";
import CreateCampaign from "./views/Campaign/CreateCampaign";
import EditCampaign from "./views/Campaign/EditCampaign";
import RegisterDisputeAdmin from "./views/DisputeManagement/RegisterAdmin";
import CategoryChangeRequests from "./views/Logs/CategoryChangeRequests";
import FraudCheckManagement from "./views/FraudCheck";
import ReversalOpsManagement from "./views/ReversalOps";
import RewardsScreen from "./views/rewards/index";


const setupResizeObserverLoopFix = () => {
    const originalError = console.error;
    console.error = (...args) => {
        if (args[0]?.includes && (args[0].includes("ResizeObserver loop completed with undelivered notifications") || args[0].includes("ResizeObserver loop limit exceeded"))) {
            return;
        }
        originalError.call(console, ...args);
    };

    window.addEventListener('error', (e) => {
        if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'ResizeObserver loop completed with undelivered notifications.') {
            e.stopImmediatePropagation();
        }
    });

    window.addEventListener('unhandledrejection', (e) => {
      if (e.reason && (e.reason.message === 'ResizeObserver loop limit exceeded' || e.reason.message === 'ResizeObserver loop completed with undelivered notifications.')) {
        e.stopImmediatePropagation();
      }
    });
};
setupResizeObserverLoopFix();

const ManagePos = React.lazy(() => import("./pos/pages/Terminals/Terminals"));
const POSTransactions = React.lazy(
  () => import("./pos/pages/Transactions/Transactions"),
);
const Defaulters = React.lazy(
  () => import("./pos/components/TransactionComponents/TermainalDefaultersLog"),
);
const TerminalReqestLog = React.lazy(
  () => import("./pos/pages/Logs/RequestLog"),
);
const TerminalActivityLogs = React.lazy(
  () => import("./pos/pages/Logs/TerminalActivityLogs"),
);
const PendingRequestsLog = React.lazy(
  () => import("./views/Logs/PendingRequestsLog"),
);
const CorporateUsers = React.lazy(() => import("./pos/pages/Users/Corporate"));
const AGDashboard = React.lazy(() => import("./views/AGDashboard"));
const ReferrerBreakdown = React.lazy(() => import("./views/AGDashboard/ReferrerBreakdown"));
const ReferralCommissionReport = React.lazy(() => import("./views/AGDashboard/ReferralCommissionReport"));
const FeesConfigurationPage = React.lazy(() => import("./views/Settings/FeesConfiguration/FeesConfigurationPage"));
const PosTargetConfigPage = React.lazy(() => import("./views/Settings/PosTargetConfig/PosTargetConfigPage"));
// import TerminalDefaulters from "./components/TransactionComponents/TermainalDefaultersLog";
// import RequestLogs from "./pages/Logs/RequestLog";

const App = () => {
  const isUserLoggedIn =
    (localStorage.getItem("token") &&
      localStorage.getItem("token") !== "undefined") ||
    (localStorage.getItem("loanAdminToken") &&
      localStorage.getItem("loanAdminToken") !== "undefined");

  useEffect(() => {
    if (!isUserLoggedIn) return;

    const refreshTimer = setInterval(async () => {
      const refreshToken = localStorage.getItem("refreshToken");
      const token = localStorage.getItem("token");

      if (!refreshToken || !token) return;

      try {
        const res = await axios.post(
          `${customBaseUrl.authUrl}/auth/refresh-token`,
          { refreshToken },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          }
        );

        if (res.data?.success) {
          const resData = res.data?.data;
          const newAccessToken = resData?.accessToken || res.data?.accessToken;
          const newRefreshToken = resData?.refreshToken || res.data?.refreshToken;

          if (newAccessToken) {
            localStorage.setItem("token", newAccessToken);
            
            // Robustly update token inside userDetails in localStorage
            const userDetailsStr = localStorage.getItem("userDetails");
            if (userDetailsStr) {
              try {
                const userDetails = JSON.parse(userDetailsStr);
                userDetails.token = newAccessToken;
                if (userDetails.user) {
                  userDetails.user.accessToken = newAccessToken;
                  if (newRefreshToken) {
                    userDetails.user.refreshToken = newRefreshToken;
                  }
                }
                localStorage.setItem("userDetails", JSON.stringify(userDetails));
              } catch (e) {
                // Ignore parse errors, fallback to standard update
              }
            }
          }

          if (newRefreshToken) {
            localStorage.setItem("refreshToken", newRefreshToken);
          }
        } else {
          // If the refresh token fails, log user out cleanly
          localStorage.clear();
          window.location.href = "/login";
        }
      } catch (error) {
        // If response is unauthorized (e.g. invalid/expired refresh token), log out
        if (error.response?.status === 401 || error.response?.status === 403) {
          localStorage.clear();
          window.location.href = "/login";
        }
      }
    }, 180000); // 3 minutes

    return () => clearInterval(refreshTimer);
  }, [isUserLoggedIn]);

  return (
    <>
      <NotificationContainer />
      <Router>
        {!isUserLoggedIn ? (
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="/auth/loan/login" element={<ApproverLogin />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/forgot_password" element={<ForgotPassword />} />
            <Route exact path="/reset_password" element={<ResetPassword />} />
            <Route
              exact
              path={slugs.loan_admin_login}
              element={<LoanAdminLogin />}
            />
            <Route
              exact
              path="/activate_account"
              element={<AdminAccountVerification />}
            />
            <Route exact path={slugs.loan} element={<LoanOverview />} />
          </Routes>
        ) : (
          <Suspense fallback={<div>Loading...</div>}>
            <ProfileContextProvider>
              <Routes>
                <Route exact path="/dashboard" element={<Dashboard />} />
                <Route exact path="/dashboard/pos" element={<PosDashboard />} />
                <Route
                  exact
                  path={slugs.pos_transactions}
                  element={<POSTransactions />}
                />
                {/* <Route exact path='/posmain' element={<POSMain/>}/> */}
                <Route
                  exact
                  path={slugs.manage_pos}
                  element={<ManagePos />}
                />
                <Route
                  exact
                  path={slugs.pos_request_logs}
                  element={<TerminalReqestLog />}
                />
                <Route
                  exact
                  path={slugs.terminal_activity_logs}
                  element={<TerminalActivityLogs />}
                />
                <Route
                  exact
                  path={slugs.defaulters_log}
                  element={<Defaulters />}
                />
                <Route
                  exact
                  path={slugs.ag_dashboard}
                  element={<AGDashboard />}
                />
                <Route
                  exact
                  path={slugs.ag_commissions}
                  element={<ReferralCommissionReport />}
                />
                <Route
                  exact
                  path={slugs.referrer_breakdown}
                  element={<ReferrerBreakdown />}
                />

                <Route
                  exact
                  path="/dashboard-analysis"
                  element={<DashboardAnalysis />}
                />

                <Route exact path="/users" element={<ManageUser />} />
                <Route exact path={slugs.all_users} element={<AllUsers />} />
                <Route
                  exact
                  path={slugs.user_details}
                  element={<CustomerDetailsScreen />}
                />
                <Route
                  exact
                  path={"/manage-corporate"}
                  element={<CorporateManagementScreen />}
                />
                <Route
                  exact
                  path={slugs.corporate_customer_reports}
                  element={<CorporateCustomerManagement />}
                />
                <Route
                  exact
                  path={slugs.customer_reports}
                  element={<CustomerManagement />}
                />
                <Route
                  exact
                  path={slugs.fees_configuration}
                  element={<FeesConfigurationPage />}
                />
                <Route
                  exact
                  path={slugs.pos_target_config}
                  element={<PosTargetConfigPage />}
                />
                <Route
                  exact
                  path={slugs.customer_reports_details}
                  element={<CustomerProfile />}
                />
                <Route
                  exact
                  path="/user-details/:merchantId"
                  element={<MerchantDetails />}
                />
                <Route exact path="/users/profile/:id" element={<Profile />} />
                <Route
                  exact
                  path="/users/profile/:id/page"
                  element={<ProfilePage />}
                />
                <Route
                  exact
                  path="/admin/profile/:id"
                  element={<EditSuperProfile />}
                />
                <Route
                  exact
                  path={slugs.manage_team}
                  element={<ManageTeam />}
                />
                <Route exact path={slugs.busers} element={<CorporateUsers />} />
                <Route exact path="/users/admin" element={<Admin />} />
                <Route
                  exact
                  path="/users/admin-details/:id"
                  element={<AdminDetailsScreen />}
                />
                <Route exact path="/users_kyc/:id" element={<Kyc />} />
                <Route exact path={slugs.manage_kyc} element={<ManageKyc />} />
                <Route
                  exact
                  path="/kyc/user_tier_levels"
                  element={<KycMainPage />}
                />
                <Route
                  exact
                  path="/user/activity_log/:id"
                  element={<UserActivityLog />}
                />
                <Route
                  exact
                  path="/user/login_tracker/:id"
                  element={<UserLoginTracker />}
                />

                <Route exact path="/waya_official" element={<WayaOfficial />} />
                <Route
                  exact
                  path="/admin/manage_roles"
                  element={<ManageAdminRoles />}
                />
                <Route
                  exact
                  path="/kyc/kyc_settings"
                  element={<KycSettings />}
                />
                <Route exact path={slugs.otp} element={<Otp />} />
                <Route
                  exact
                  path="/activate_account"
                  element={<AdminAccountVerification />}
                />
                <Route
                  exact
                  path="/kyc/business_types"
                  element={<BusinessType />}
                />

                <Route
                  exact
                  path={slugs.all_transactions}
                  element={<AllTransaction />}
                />
                <Route
                  exact
                  path="/transaction/:id"
                  element={<Transaction />}
                />
                {/* <Route exact path={slugs.transfer_inceptor} element={<TransferInceptor />} /> */}
                <Route
                  exact
                  path={slugs.smu_transactions}
                  element={<SMUTransactions />}
                />
                <Route
                  exact
                  path={slugs.transaction_charge}
                  element={<ChangeTransactionCharges />}
                />
                <Route
                  exact
                  path={slugs.change_charge}
                  element={<ChangeTransactionCharges />}
                />
                <Route
                  exact
                  path={slugs.non_waya_transfer}
                  element={<NonWayaTransfer />}
                />
                <Route
                  exact
                  path={slugs.trans_accounts}
                  element={<Accounts />}
                />
                <Route
                  exact
                  path={slugs.payment_request}
                  element={<PaymentRequest />}
                />
                <Route
                  exact
                  path={slugs.trans_commissions}
                  element={<Commission />}
                />
                <Route
                  exact
                  path={slugs.trans_commissions}
                  element={<Commission />}
                />
                <Route
                  exact
                  path="/transactions_history/:id/:clientId"
                  element={<MerchantTransactionsPage />}
                />
                <Route
                  exact
                  path={slugs.transaction_p}
                  element={<ProductsTransactions />}
                />
                <Route
                  exact
                  path={slugs.transactions}
                  element={<TransactionList />}
                />
                <Route
                  exact
                  path={slugs.bills_payment}
                  element={<BillsPayment />}
                />
                <Route
                  exact
                  path={slugs.nip_inward_reconciliation}
                  element={<NipInwardReconciliation />}
                />

                <Route
                  exact
                  path={slugs.referral}
                  element={<ManageRefferrals />}
                />
                <Route
                  exact
                  path="/referral/no_of_transactions"
                  element={<TransactionsDone />}
                />
                <Route
                  exact
                  path="/referral/bonus_earned"
                  element={<BonusEarned />}
                />
                <Route exact path="/referrals/:id" element={<Referrals />} />
                <Route exact path={slugs.disputes} element={<Disputes />} />
                <Route exact path={slugs.report} element={<ManualReport />} />
                <Route exact path={"/routing"} element={<Routing />} />

                <Route exact path={slugs.cards} element={<CardsMainPage />} />
                <Route
                  exact
                  path={slugs.bulk_cards}
                  element={<BulkCardMain />}
                />
                <Route exact path={slugs.rewards} element={<RewardsScreen />} />
                <Route
                  exact
                  path={slugs.agre_bill}
                  element={<AggreegatorBill />}
                />
                <Route
                  exact
                  path={slugs.pricing}
                  element={<ProductPricing />}
                />
                <Route
                  exact
                  path={slugs.tech_pricing}
                  element={<MainPricing />}
                />
                <Route exact path="/tech_admin" element={<AdminVendors />} />
                <Route
                  exact
                  path={slugs.overview_tech}
                  element={<TechOverview />}
                />
                <Route
                  exact
                  path="/simulated_users_fund"
                  element={<SimulatedUsersFund />}
                />
                <Route
                  exact
                  path={slugs.tech_users_overview}
                  element={<UsersOverview />}
                />
                <Route
                  exact
                  path={slugs.simulated_users}
                  element={<SimulatedUsers />}
                />

                <Route exact path="/qr_codes" element={<QR />} />
                <Route exact path="/dispute" element={<Dispute />} />
                <Route
                  exact
                  path={slugs.requests_logs}
                  element={<RequestLogs />}
                />
                <Route
                  exact
                  path={slugs.admin_audit}
                  element={<AdminAuditLogs />}
                />
                <Route
                  exact
                  path={slugs.fraudManagement_log}
                  element={<FraudManagement />}
                />
                <Route
                  exact
                  path={slugs.pending_requests_log}
                  element={<PendingRequestsLog />}
                />

                <Route exact path={slugs.feedback} element={<FeedBack />} />

                <Route
                  exact
                  path={slugs.bills_pay}
                  element={<BillsPayment />}
                />

                <Route
                  exact
                  path={slugs.terms_conditions}
                  element={<TermsCondition />}
                />
                <Route exact path={slugs.privacy} element={<Privacy />} />

                <Route exact path={slugs.loan} element={<LoanOverview />} />
                <Route
                  exact
                  path={slugs.loan_admins}
                  element={<LoanAdmins />}
                />
                <Route
                  exact
                  path={slugs.loan_analytics_dashboard}
                  element={<LoanAdminDashboard />}
                />
                <Route
                  exact
                  path={slugs.loan_admin_dashboard}
                  element={<LoanAdminDashboard from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_disbursement_dashboard}
                  element={<FinanceApproverDisbursement from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_approval_dashboard}
                  element={<LoanPendingLoans from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_pending_loans}
                  element={<LoanPendingLoans />}
                />
                <Route
                  exact
                  path={slugs.finance_approver_disbursement}
                  element={<FinanceApproverDisbursement />}
                />
                <Route
                  exact
                  path={slugs.loan_details}
                  element={<LoanDetailsPage />}
                />
                <Route
                  exact
                  path={slugs.loan_details_admin}
                  element={<LoanDetailsPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_officer_details}
                  element={<LoanOfficerDetailsPage />}
                />
                <Route
                  exact
                  path={slugs.finance_officer_details}
                  element={<FinanceOfficerDetailsPage />}
                />
                <Route
                  exact
                  path={slugs.loan_officer_details_admin}
                  element={<LoanOfficerDetailsPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.finance_officer_details_admin}
                  element={<FinanceOfficerDetailsPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_view}
                  element={<LoanViewPage />}
                />
                <Route
                  exact
                  path={slugs.loan_admin_view}
                  element={<LoanViewPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_disbursement}
                  element={<Disbursement />}
                />
                {/* <Route
                  exact
                  path={slugs.loan_disbursement_dashboard}
                  element={<Disbursement from="admin" />}
                /> */}
                <Route
                  exact
                  path={slugs.loan_summary}
                  element={<AdminSummaryPage />}
                />
                <Route
                  exact
                  path={slugs.loan_admin_summary}
                  element={<AdminSummaryPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.all_loan_requests}
                  element={<AllLoansPage />}
                />
                <Route
                  exact
                  path={slugs.loan_audit_logs}
                  element={<LoanAuditLogsPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.all_loans_admin}
                  element={<AllLoansPage from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loans_by_status}
                  element={<LoansByStatusPage />}
                />
                <Route
                  exact
                  path={slugs.apply_for_loan}
                  element={<ApplyForLoan />}
                />
                <Route
                  exact
                  path={slugs.apply_for_loan_admin}
                  element={<ApplyForLoan from="admin" />}
                />
                <Route
                  exact
                  path={slugs.loan_settings}
                  element={<LoanSettings from="admin" />}
                />

                {/* B2B Products Routes */}
                <Route
                  exact
                  path={slugs.b2b_products}
                  element={<B2BProducts />}
                />
                <Route
                  exact
                  path={slugs.b2b_product_pricing}
                  element={<ProductPricingPage />}
                />
                <Route
                  exact
                  path={slugs.b2b_product_transactions}
                  element={<ProductTransactionsPage />}
                />
                <Route
                  exact
                  path={slugs.b2b_merchant_transactions}
                  element={<MerchantTransactionsPage />}
                />
                <Route
                  exact
                  path={slugs.b2b_reports}
                  element={<B2BReports />}
                />

                {/* Settings Routes */}
                <Route exact path={slugs.settings} element={<Settings />} />
                <Route
                  exact
                  path={slugs.app_settings}
                  element={<AppSettings />}
                />
                <Route
                  exact
                  path={slugs.vendor_settings}
                  element={<Vendors />}
                />

                {/* Activity Logs Route */}
                <Route
                  exact
                  path={slugs.activity_logs}
                  element={<ActivityLogs />}
                />

                {/* Audit Trail Management Route */}
                <Route
                  exact
                  path={slugs.audit_trail}
                  element={<AuditTrail />}
                />

                {/* Regulatory Reporting Route */}
                <Route
                  exact
                  path={slugs.regulatory_reporting}
                  element={<RegulatoryReporting />}
                />

                {/* Internal Reporting Route */}
                <Route
                  exact
                  path={slugs.internal_reporting}
                  element={<InternalReporting />}
                />

                <Route
                  exact
                  path={slugs.campaigns}
                  element={<CampaignList />}
                />
                <Route
                  exact
                  path={slugs.active_campaigns}
                  element={<CampaignList from="active" />}
                />
                <Route
                  exact
                  path={slugs.create_campaign}
                  element={<CreateCampaign />}
                />
                <Route
                  exact
                  path={slugs.edit_campaign}
                  element={<EditCampaign />}
                />

                <Route
                  exact
                  path={slugs.commission_types}
                  element={<CommissionTypeList />}
                />
                <Route
                  exact
                  path={slugs.commission_configurations}
                  element={<CommissionConfigList />}
                />



                <Route
                  exact
                  path={slugs.customer_reports}
                  element={<CustomerManagementReports />}
                />
                <Route
                  exact
                  path={slugs.corporate_customer_reports}
                  element={<CorporateCustomerReports />}
                />

                <Route
                  exact
                  path={slugs.register_dispute_admin}
                  element={<RegisterDisputeAdmin />}
                />
                <Route
                  exact
                  path={slugs.category_change_requests}
                  element={<CategoryChangeRequests />}
                />
                <Route
                  exact
                  path={slugs.fraud_check}
                  element={<FraudCheckManagement />}
                />
                <Route
                  exact
                  path={slugs.reversal_ops}
                  element={<ReversalOpsManagement />}
                />
                <Route path="*" element={<ComingSoon />} />
                <Route
                  exact
                  path={slugs.otp_management}
                  element={<OtpManagement />}
                />

                <Route 
                  path="" 
                  element={(() => {
                    const rawRoles = localStorage.getItem('roles');
                    let userRoles = [];
                    try {
                      userRoles = JSON.parse(rawRoles || '[]');
                      if (!Array.isArray(userRoles)) userRoles = [userRoles];
                    } catch {
                      userRoles = rawRoles ? [rawRoles] : [];
                    }
                    const isMarketerOnly = userRoles.includes('MARKETER') && userRoles.length === 1;
                    return isMarketerOnly ? <Navigate to="/campaigns" replace /> : <Dashboard />;
                  })()} 
                />
              </Routes>
            </ProfileContextProvider>
          </Suspense>
        )}
      </Router>
    </>
  );
};

export default App;
